/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import maskAmount from 'utils/maskAmount';
import { TextInput, Form, Button } from 'components/common';
import { getCurrency } from 'models/payment';

const MakeBidSide = ({
  t, setVisible, offers, setCheckBidModalData, setHowToAuctionWorkModalVisible, machine, minimumIncrement,
}) => {
  const [amount, setAmount] = useState('');
  const [unmaskedAmount, setUnmaskedAmount] = useState('');
  const [header, setHeader] = useState();
  const [formRef, setFormRef] = useState(useRef());
  const [currency, setCurrency] = useState(0);

  useEffect(() => {
    currencyEuroFromTl();
  }, []);

  const currencyEuroFromTl = async () => {
    const approxValue = await getCurrency(offers?.length > 0 ? offers[0].offer : machine.auctionStartPrice);
    setCurrency(approxValue);
  };

  const handleAmount = ({ value }) => {
    const fixedInput = value.replace(/[^0-9]/g, '');

    const maskedAmountValue = maskAmount(fixedInput, 'EUR', true);

    formRef.setFieldsValue({
      amount: maskedAmountValue,
    });

    setAmount(maskedAmountValue);
    setUnmaskedAmount(fixedInput);
  };

  const makeBid = async () => {
    if ((offers.length > 0 && unmaskedAmount > offers[0]?.offer) || (offers.length === 0 && unmaskedAmount > machine.auctionStartPrice)) {
      setVisible(false);
      setTimeout(() => {
        setCheckBidModalData({
          amount: unmaskedAmount,
        });
      }, 500);
    } else {
      setHeader({
        title: 'Teklifiniz onaylanmadı!',
        subtitle: 'Teklifiniz en yüksek tekliften düşük.',
      });
    }
  };

  return (
    <div className="col-15 col-sm">
      <div className="im-box im-box--white im-box--border-radius im-box--mh-100">
        {
          header
         && (
           <div>
             <div className="fs-18 text-red1 mb-3 text-center fw-900">{header?.title}</div>
             <div className="fs-14 text-red1 mb-3 text-center">{header?.subtitle}</div>
           </div>
         )
        }
        <div className="text-center mt-5 mb-5">
          <div className="fs-35 fw-900 mb-2">{maskAmount(offers?.length > 0 ? offers[0].offer : machine.auctionStartPrice)}</div>
          <div className="fs-15">{offers?.length > 0 ? t('currentHighOffer') : 'Başlangıç Fiyatı'}</div>
          <div className="fs-13 text-gray3 mt-1">
            {`(${t('approx')} ${maskAmount(currency, 'TRY')})`}
          </div>
        </div>
        <div className="row align-items-center justify-content-center mb-5">
          <div className="col-auto text-center">
            <div className="fs-15 fw-900 text-gray3 mb-2">{maskAmount(minimumIncrement)}</div>
            <div className="fs-12 text-gray3">{t('priceIncrease')}</div>
          </div>
          <div className="col-auto text-center">
            <div className="fs-15 fw-900 text-gray3 mb-2">{offers?.length ? offers.length : 0}</div>
            <div className="fs-12 text-gray3">{t('numberOfOffers')}</div>
          </div>
        </div>

        <Form
          layout="horizontal"
          onFinish={makeBid}
          formRef={(ref) => setFormRef(ref)}
        >
          <div className="row">
            <div className="col-15 mb-2">
              <div className="im-input im-input--type2 im-input--prefix">
                <div className="im-input__prefix">€</div>
                <TextInput
                  name="amount"
                  placeholder="Lütfen teklif tutarınızı giriniz."
                  value={amount}
                  onChange={handleAmount}
                  formRef={formRef}
                  style={{ fontSize: 18, width: '100%' }}
                  hideLabel
                  formItemStyle={{
                    marginBottom: '0',
                    width: '100%',
                  }}
                />
              </div>
            </div>
            <div className="col-15">
              <Button
                htmlType="submit"
                className="im-button im-button--primary im-button--size-60 im-button--center im-button--fluid fw-900"
                label="Teklifini Kontrol Et"
              />
            </div>
            <div className="col-15 mt-3 text-center">
              <span className="fs-12 fw-500 text-gray3">
                Teklifiniz
                {' '}
                <span className="fw-900">bir sonraki sayfada</span>
                {' '}
                onaylanacaktır.
              </span>
            </div>
          </div>
        </Form>

        <div className="row mt-5 mb-3">
          <div className="col">
            <a
              className="d-flex align-items-center justify-content-center"
              onClick={() => {
                setVisible(false);
                setTimeout(() => {
                  setHowToAuctionWorkModalVisible(true);
                }, 500);
              }}
            >
              <span className="fs-13 fw-400 d-inline-block">{t('howBiddingWorks')}</span>
              <i className="fa-solid fa-question-circle ml-2" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

MakeBidSide.propTypes = {
  t: PropTypes.func,
  setVisible: PropTypes.func,
  offers: PropTypes.array,
  setCheckBidModalData: PropTypes.func,
  setHowToAuctionWorkModalVisible: PropTypes.func,
  machine: PropTypes.object,
  minimumIncrement: PropTypes.number,
};

export default withTranslation('common')(MakeBidSide);
